import { render, staticRenderFns } from "./subscriptionHis.vue?vue&type=template&id=52f0f7ba&scoped=true"
import script from "./subscriptionHis.vue?vue&type=script&lang=js"
export * from "./subscriptionHis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f0f7ba",
  null
  
)

export default component.exports